// Utilities
import { builderFetch } from '@builder/core/utilities';
import { html } from 'lit';
const { confirm, isEmpty } = _uo.utility;

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.item.deleteItem;

/**
 * Deletes an item from the recipe
 *
 * @param {String} itemType The item type (e.g. trigger)
 * @param {Number} itemId The item ID
 * @param {Object} atts The attributes. @todo Remove this once the new recipe object is implemented.
 * @return {Promise} The apiFetch promise
 */
const deleteItem = async ( itemType, itemId, atts = {} ) => {
	// Get the item
	const item = UncannyAutomator._core.recipe.item.getItem( itemType, itemId );

	// If the item is not define, stop here
	if ( isEmpty( item ) ) {
		throw new Error( `deleteItem: The item ${ itemType } ${ itemId } doesn't exist` );
	}

	if (
		/**
		 * @todo Remove this once the new recipe object is implemented and all the validations are moved to this file.
		 */
		! atts.__deprecated__ignoreValidation &&

		// Check if the recipe is live
		UncannyAutomator._recipe.is_recipe_on &&
		// Check if the item itself is also live
		item.is_item_on
	) {
		await confirm( {
			content: html`
				<uo-alert type="warning">
					${ strings.warningMessage }
				</uo-alert>
			`
		} );
	}

	// Save the recipe title
	return builderFetch( {
		endpoint: 'delete',
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			recipe_id: UncannyAutomator._recipe.recipe_id,
			ID: itemId,
		},
		snackbar: {
			loading: itemType === 'trigger' ? strings.deletingTrigger : strings.deletingAction,
			success: itemType === 'trigger' ? strings.triggerDeleted : strings.actionDeleted,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/item/delete-item', {
				detail: {
					itemID: itemId
				}
			} ) );
		}

		return response;
	} );
}

export default deleteItem;
